import { ContentfulTableOfContents } from '@jbhi-fi/apis/src/contentful/types';
import { TableOfContentsProps } from '../../TableOfContents/TableOfContents';
import { toUrlSlug } from '@jbhi-fi/utils/src/toUrlSlug/toUrlSlug';

export abstract class TableOfContentsTransformer {
  static toTableOfContentsProps = (entry: ContentfulTableOfContents): TableOfContentsProps => {
    return {
      heading: entry?.fields?.heading ?? '',
      items:
        entry?.fields?.anchors?.map(anchor => ({
          label: anchor?.fields?.heading ?? '',
          href: `#${toUrlSlug(anchor?.fields?.heading ?? '')}`,
        })) ?? [],
    };
  };
}
